module.exports = __webpack_public_path__ + "img/play.7a2d150a.svg";